import React from 'react'
import './StitchActionPad.css'

const ArrowIcon = ({ direction = 'up', duplicate = false }) => {
  const rotationMap = {
    up: '0deg',
    right: '90deg',
    down: '180deg',
    left: '-90deg',
  }

  return (
    <svg
      className="stitch-pad-icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ transform: `rotate(${rotationMap[direction] || '0deg'})` }}
    >
      <path d="M12 4 L12 20" />
      <path d="M6.5 9.5 L12 4 L17.5 9.5" />
      {duplicate ? <path d="M7 18.5 H17" /> : null}
    </svg>
  )
}

const PadButton = ({
  title,
  onClick,
  children,
  danger = false,
  wide = false,
  duplicate = false,
}) => (
  <button
    type="button"
    className={`stitch-pad-btn${danger ? ' danger' : ''}${wide ? ' wide' : ''}${duplicate ? ' duplicate' : ''}`}
    onClick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      onClick?.()
    }}
    title={title}
    aria-label={title}
  >
    {children}
  </button>
)

const StitchActionPad = ({
  top,
  left,
  onMoveUp,
  onMoveRight,
  onMoveDown,
  onMoveLeft,
  onDuplicateUp,
  onDuplicateRight,
  onDuplicateDown,
  onDuplicateLeft,
  onDelete,
  onClose,
  onGrabMouseDown,
}) => {
  return (
    <div
      className="stitch-action-pad"
      style={{
        top,
        left,
        transform: 'none',
      }}
      onMouseDown={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      <div
        className="stitch-pad-grab-handle"
        onMouseDown={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onGrabMouseDown?.(e)
        }}
        title="Drag pad"
        aria-label="Drag pad"
      />

      <div className="stitch-pad-grid horizontal-layout">
        <div className="stitch-pad-column">
          <div className="stitch-pad-section-label">MOVE</div>

          <div className="stitch-pad-cell">
            <PadButton title="Move up" onClick={onMoveUp}>
              <ArrowIcon direction="up" />
            </PadButton>
          </div>

          <div className="stitch-pad-cell horizontal">
            <PadButton title="Move left" onClick={onMoveLeft}>
              <ArrowIcon direction="left" />
            </PadButton>
            <PadButton title="Done" onClick={onClose} wide>
              DONE
            </PadButton>
            <PadButton title="Move right" onClick={onMoveRight}>
              <ArrowIcon direction="right" />
            </PadButton>
          </div>

          <div className="stitch-pad-cell">
            <PadButton title="Move down" onClick={onMoveDown}>
              <ArrowIcon direction="down" />
            </PadButton>
          </div>
        </div>

        <div className="stitch-pad-divider vertical" />

        <div className="stitch-pad-column">
          <div className="stitch-pad-section-label duplicate-label">DUPLICATE</div>

          <div className="stitch-pad-cell">
            <PadButton title="Duplicate up" onClick={onDuplicateUp} duplicate>
              <ArrowIcon direction="up" duplicate />
            </PadButton>
          </div>

          <div className="stitch-pad-cell horizontal">
            <PadButton title="Duplicate left" onClick={onDuplicateLeft} duplicate>
              <ArrowIcon direction="left" duplicate />
            </PadButton>
            <PadButton title="Duplicate right" onClick={onDuplicateRight} duplicate>
              <ArrowIcon direction="right" duplicate />
            </PadButton>
          </div>

          <div className="stitch-pad-cell">
            <PadButton title="Duplicate down" onClick={onDuplicateDown} duplicate>
              <ArrowIcon direction="down" duplicate />
            </PadButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StitchActionPad